<template>
  <div class="emoji-picker">
    <el-popover width="auto" trigger="click" :visible-arrow="false" :placement="pickerPlacement" popper-class="emoji-picker__popper">
      <picker
        :showPreview="false"
        :showSearch="false"
        :showSkinTones="false"
        color="#1989fa"
        native
        :i18n="i18n"
        @select="onPick"
      />
      <div class="emoji-picker__button" slot="reference">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
            stroke="#C6CAD1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 14C8 14 9.5 16 12 16C14.5 16 16 14 16 14"
            stroke="#C6CAD1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 9H9.01"
            stroke="#C6CAD1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15 9H15.01"
            stroke="#C6CAD1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </el-popover>
  </div>
</template>
<script>
  import _ from 'lodash'
  import Vue from 'vue'
  import {Picker} from 'emoji-mart-vue'
  export default {
    name: 'EmojiPicker',
    props: {
      placementDesktop: {
        type: String
      },
      placementMobile: {
        type: String
      }
    },
    components: {Picker},
    created () {
      window.addEventListener('resize', this.resizeHandler);
      this.resizeHandler();
    },
    destroyed () {
      window.removeEventListener('resize', this.resizeHandler);
    },
    data () {
      return {
        i18n: {
          search: this.$t('labels.search'),
          notfound: this.$t('labels.nothing_founded'),
          categories: {
            search: this.$t('labels.emoji.search'),
            recent: this.$t('labels.emoji.recent'),
            people: this.$t('labels.emoji.people'),
            nature: this.$t('labels.emoji.nature'),
            foods: this.$t('labels.emoji.foods'),
            activity: this.$t('labels.emoji.activity'),
            places: this.$t('labels.emoji.places'),
            objects: this.$t('labels.emoji.objects'),
            symbols: this.$t('labels.emoji.symbols'),
            flags: this.$t('labels.emoji.flags'),
            custom: this.$t('labels.emoji.custom')
          }
        },
        pickerPlacement: this.placementMobile || 'top'
      }
    },
    methods: {
      onPick (emoji) {
        this.$emit('pickEmoji', emoji.native)
      },
      resizeHandler: _.debounce(function () {
        if (window.innerWidth >= 421) {
          this.pickerPlacement = this.placementDesktop || 'top-start';
        } else {
          this.pickerPlacement = this.placementMobile || 'top';
        }
      }, 500)
    }
  }
</script>
<style lang="scss">
  .emoji-picker {
    display: inline-block;
    width: 29px;

    &, * {
      outline: none;
    }

    &__popper {
      padding: 0 !important;
      background: transparent !important;
    }

    &__button {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .emoji-mart {
    max-width: 318px;
  }

  .emoji-picker__popper.el-popover {
    transition: 0.2s;
    border: none;
    box-shadow: none;
  }

  .emoji-mart-category .emoji-mart-emoji span[style] {
    cursor: pointer;
    font-size: 20px !important;
  }

  @media (max-width: 420px) {
    .emoji-picker__popper {
      width: 318px;
      left: calc(50% - 159px) !important;
    }
    .emoji-mart {
      margin-left: auto;
      margin-right: auto;
      left: 0;
    }
  }
</style>